export const USER = "user";
export const PERMISSIONS = "permissions";
export const ACCESS_TOKEN = "accessToken";
export const REFRESH_TOKEN = "refreshToken";
export const CUSTOMER_STYLING = "customerStyling";
export const BROWSER_BRANDING = "browserBranding";
export const DASHBOARDS = "dashboards";
export const STACK_TRACE = "stackTrace";
export const ERROR = "error";
/** Unsaved "new knowledge article" form metadata (titles/HTML/settings). File bytes live in IndexedDB. */
export const KNOWLEDGE_ARTICLE_NEW_DRAFT = "knowledgeArticleNewDraft";

/** Prefix for cached i18n bundles: `${I18N_CACHE_PREFIX}${languageCode}` */
export const I18N_CACHE_PREFIX = "i18n_";

export const i18nCacheKey = (languageCode: string): string => `${I18N_CACHE_PREFIX}${languageCode}`;
